module.exports = __webpack_public_path__ + "static/media/recipes-page.79615ada.jpeg";